export class ReportFinancialFilterModel {
  initialDate: Date;
  endDate: Date;
  PracticeId: number;
  PracticeLocations: string[];
  ProvidersId: string[];
  isProvider: boolean;
  isPractice: boolean;
  isCurrentMonth: boolean;

  }
